export default __webpack_public_path__ + "static/media/mobile-tour-goal-img.ed6d2378.svg";